module.exports = __webpack_public_path__ + "static/img/activity01.1847315d.png";